import React from 'react';
import { Breadcrumb as AntBreadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

interface Props {
  prefix: string;
  onNavigate: (prefix: string) => void;
}

const Breadcrumb = ({ prefix, onNavigate }: Props) => {
  const parts = prefix ? prefix.replace(/\/$/, '').split('/') : [];

  return (
    <AntBreadcrumb style={{ marginBottom: 16 }}>
      <AntBreadcrumb.Item>
        <span onClick={() => onNavigate('')} style={{ cursor: 'pointer' }}>
          <HomeOutlined /> Root
        </span>
      </AntBreadcrumb.Item>
      {parts.map((part, index) => {
        const targetPrefix = parts.slice(0, index + 1).join('/') + '/';
        const isLast = index === parts.length - 1;
        return (
          <AntBreadcrumb.Item key={targetPrefix}>
            {isLast
              ? <span>{part}</span>
              : <span onClick={() => onNavigate(targetPrefix)} style={{ cursor: 'pointer' }}>{part}</span>
            }
          </AntBreadcrumb.Item>
        );
      })}
    </AntBreadcrumb>
  );
};

export default Breadcrumb;
